import type { TreeNode } from 'tree-model';

import type { TreeReducerModel } from './types';

/**
 * The tree-model library keeps a mutable `children` array on every node model. Storing such a
 * model in a slice makes immer freeze that array, which breaks any later tree mutation, so keep
 * the plain item data only. Items without `children` are returned as is to preserve their
 * identity.
 */
export function detachFromTree<T extends object>(items: T[]): T[] {
  return items.map((item) => {
    if ('children' in item) {
      // The rest keeps every other field, so it still stands in for the item.
      const { children, ...rest } = item;
      // biome-ignore lint/plugin: see above.
      return rest as unknown as T;
    }
    return item;
  });
}

/**
 * Replaces a frozen `model.children` with a mutable copy, so that tree-model can splice it when
 * branches are added or removed.
 */
export function unfreezeChildren(node: TreeNode<TreeReducerModel>) {
  const { children } = node.model;
  if (children && Object.isFrozen(children)) {
    node.model = { ...node.model, children: [...children] };
  }
}
